const indexItems = [
  { id: 1, label: '娱乐圈恋情', count: '128篇', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { id: 2, label: '综艺内幕爆料', count: '96篇', icon: 'ri-tv-line', color: 'bg-accent-100 text-accent-600' },
  { id: 3, label: '网红黑料合集', count: '87篇', icon: 'ri-alert-line', color: 'bg-secondary-100 text-secondary-600' },
  { id: 4, label: '明星婚变追踪', count: '74篇', icon: 'ri-emotion-sad-line', color: 'bg-primary-100 text-primary-600' },
  { id: 5, label: '影视剧路透', count: '65篇', icon: 'ri-film-line', color: 'bg-accent-100 text-accent-600' },
  { id: 6, label: '饭圈动态', count: '58篇', icon: 'ri-group-line', color: 'bg-secondary-100 text-secondary-600' },
  { id: 7, label: '吃瓜周报汇总', count: '42篇', icon: 'ri-newspaper-line', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">专题索引</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            按主题分类浏览51吃瓜网站的丰富内容，快速找到你感兴趣的吃瓜方向
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/60 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}